import { DESCRIPTION_SUFFIX } from "@/constant";

export const setTitleAndDescription = ({title, description, siteName}) => {
    const finalTitle = title || (process.env.REACT_APP_PROJECT_NAME || 'Impulse');
    const finalDescription = description || `${finalTitle} - ${DESCRIPTION_SUFFIX}`;
    document.title = finalTitle;

    const setMeta = (attribute, key, content) => {
        let tag = document.querySelector(`meta[${attribute}="${key}"]`);
        if (!tag) {
            tag = document.createElement('meta');
            tag.setAttribute(attribute, key);
            document.head.appendChild(tag);
        }
        tag.setAttribute('content', content);
    };

    setMeta('name', 'description', finalDescription);
    setMeta('name', 'twitter:card', 'summary');
    setMeta('name', 'twitter:title', finalTitle);
    setMeta('name', 'twitter:description', finalDescription);
    setMeta('property', 'og:type', 'website');
    setMeta('property', 'og:title', finalTitle);
    setMeta('property', 'og:description', finalDescription);
    setMeta('property', 'og:site_name', siteName || finalTitle);
    setMeta('property', 'og:url', window.location.origin + window.location.pathname);

    let schema = document.getElementById('platform-seo-schema');
    if (!schema) {
        schema = document.createElement('script');
        schema.id = 'platform-seo-schema';
        schema.type = 'application/ld+json';
        document.head.appendChild(schema);
    }
    schema.textContent = JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'WebSite',
        name: finalTitle,
        description: finalDescription,
        url: window.location.origin + '/',
    });
}
